import useTranslator from "../../../../hooks/useTranslator";
import lockIcon from "../../../../assets/img/lockIcon.svg";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { FiCamera, FiClock, FiUserCheck } from "react-icons/fi";

const VerificationStartScreen = ({
  onStart,
  isLoading = false,
}: {
  onStart: () => void;
  isLoading?: boolean;
}) => {
  const { _t } = useTranslator();

  const expectations = [
    {
      icon: <FiCamera aria-hidden="true" />,
      text: _t("takeAPhotoOfYourDocumentOrUploadItFromYourDevice"),
    },
    {
      icon: <FiUserCheck aria-hidden="true" />,
      text: _t("theDocumentMustIncludeYourPhotoANieWithoutAPhotoIsNotValid"),
    },
    {
      icon: <FiClock aria-hidden="true" />,
      text: _t("theResultIsUsuallyReadyInLessThanAMinute"),
    },
  ];

  return (
    <div className="kyc-verification-start">
      <div className="kyc-verification-start-icon" aria-hidden="true">
        <BadgeOutlinedIcon />
      </div>

      <div className="kyc-verification-start-copy">
        <h3>{_t("verifyYourIdentity")}</h3>
        <p>{_t("haveYourDniPassportOrResidenceCardReady")}</p>
      </div>

      <div className="kyc-verification-expectations">
        {expectations.map(({ icon, text }) => (
          <div className="kyc-verification-expectation" key={text}>
            <span className="kyc-verification-expectation-icon">{icon}</span>
            <strong>{text}</strong>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="btnNext kyc-verification-start-button"
        onClick={onStart}
        disabled={isLoading}
        aria-busy={isLoading}
      >
        {isLoading && (
          <span
            className="kyc-verification-start-button-spinner"
            aria-hidden="true"
          />
        )}
        {isLoading ? _t("startingVerification") : _t("startVerification")}
      </button>

      <p className="kyc-verification-legal">
        {_t("identityVerificationAmlLegalCopy")}{" "}
        <a
          href="https://skortorent.com/legal-notice.html"
          target="_blank"
          rel="noreferrer"
        >
          {_t("moreInformation")}
        </a>
      </p>

      <div className="kyc-verification-encrypted-note">
        <img src={lockIcon} alt="" />
        <span>{_t("yourDataIsEncrypted")}</span>
      </div>
    </div>
  );
};

export default VerificationStartScreen;
